<div class="form--field-container">
  <span class="form--select-container">
    <select class="form--select"
      [attr.id]="fieldId"
      [(ngModel)]="selectedOperator"
      (change)="toggleValueVisibility()">
      @for (operator of operators; track operator) {
        <option
          [textContent]="operator.label"
          [ngValue]="operator">
        </option>
      }
    </select>
  </span>
  @if (valueVisible) {
    <span class="form--text-field-container -slim">
      <op-basic-single-date-picker [id]="fieldId + '_visible'"
        [name]="fieldId + '_input'"
        [value]="fieldValue"
        (valueChange)="updateField($event)"
        classes="form--text-field" />
    </span>
  }
  <input type="hidden"
    [name]="fieldName"
    [value]="fieldValue"/>
</div>
